<div class="payment-methods-container">
  <div class="d-flex justify-content-center justify-content-sm-between align-items-center mb-3">
    <h5 class="mb-0 d-none d-sm-block">Payment Methods</h5>
    @if (isOwnProfile() && !showAddForm()) {
      <button type="button" class="btn btn-primary btn-sm" (click)="showPaymentMethodTypeSelector()"
        [disabled]="isLoading()">
        <i class="bi bi-plus-lg me-1"></i> Add Payment Method
      </button>
    }
  </div>

  <!-- Loading State -->
  @if (isLoading()) {
    <div class="d-flex justify-content-center align-items-center p-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="ms-3">Loading payment methods...</span>
    </div>
  }

  <!-- Error State -->
  @if (errorMessage() && !isLoading()) {
    <div class="alert alert-danger" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ errorMessage() }}
    </div>
  }

  <!-- Payment Method Type Selector -->
  @if (showAddForm() && !selectedPaymentMethodType()) {
    <div class="card mb-3">
      <div class="card-body">
        <h6 class="card-title mb-3">Add Payment Method</h6>
        <button type="button" class="card mb-2 cursor-pointer payment-method-option w-100 text-start border bg-transparent p-0"
          (click)="selectPaymentMethodType(PaymentMethodType.Card)">
          <div class="card-body d-flex justify-content-between align-items-center py-2">
            <div class="d-flex align-items-center">
              <fa-icon [icon]="['fad', 'credit-card']" class="fs-4 me-3 text-primary"></fa-icon>
              <div>
                <div class="fw-semibold">Credit Card</div>
                <small class="text-muted">Visa, Mastercard, American Express, etc.</small>
              </div>
            </div>
            <fa-icon [icon]="['fad', 'chevron-right']" class="text-muted"></fa-icon>
          </div>
        </button>
        <button type="button" class="card mb-0 cursor-pointer payment-method-option w-100 text-start border bg-transparent p-0"
          (click)="selectPaymentMethodType(PaymentMethodType.AchDebit)">
          <div class="card-body d-flex justify-content-between align-items-center py-2">
            <div class="d-flex align-items-center">
              <fa-icon [icon]="['fad', 'building-columns']" class="fs-4 me-3 text-primary"></fa-icon>
              <div>
                <div class="fw-semibold">Bank Account (ACH)</div>
                <small class="text-muted">Verified via microdeposits</small>
              </div>
            </div>
            <fa-icon [icon]="['fad', 'chevron-right']" class="text-muted"></fa-icon>
          </div>
        </button>
        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="btn btn-outline-secondary" (click)="onAddFormCancelled()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Add Card Form -->
  @if (selectedPaymentMethodType() === PaymentMethodType.Card) {
    <div class="card mb-3">
      <div class="card-body">
        <h6 class="card-title mb-3">Add Credit Card</h6>
        <ms-stripe-add-credit-card
          #addCreditCardComponent
          [userId]="user().userId"
          (paymentMethodSaved)="onPaymentMethodSaved()"
          (cancelled)="onAddFormCancelled()">
        </ms-stripe-add-credit-card>
      </div>
    </div>
  }

  <!-- Add Bank Account Form -->
  @if (selectedPaymentMethodType() === PaymentMethodType.AchDebit) {
    <div class="card mb-3">
      <div class="card-body">
        <h6 class="card-title mb-3">Add Bank Account</h6>
        <ms-stripe-add-bank-account
          [userId]="user().userId"
          (paymentMethodSaved)="onPaymentMethodSaved()"
          (cancelled)="onAddFormCancelled()">
        </ms-stripe-add-bank-account>
      </div>
    </div>
  }

  <!-- Payment Methods List -->
  @if (!isLoading() && !errorMessage()) {
    @if (paymentMethods().length === 0 && !showAddForm()) {
      <div class="text-center text-muted py-4">
        <i class="bi bi-credit-card fs-1 d-block mb-2"></i>
        <p>No payment methods on file.</p>
        @if (isOwnProfile()) {
          <p class="small">Click "Add Payment Method" to get started.</p>
        }
      </div>
    }

    @for (method of paymentMethods(); track method.id) {
      <div class="card mb-2">
        <div class="card-body d-flex justify-content-between align-items-center py-2">
          <div class="d-flex align-items-center">
            <fa-icon [icon]="getPaymentMethodIcon(method)" class="fs-4 me-3 text-primary"></fa-icon>
            <div>
              <div class="fw-semibold">
                {{ getCardDisplayName(method) }}
              </div>
              @if (method.paymentMethodType === PaymentMethodType.Card && method.card) {
                <small class="text-muted">Expires {{ getCardExpiry(method) }}</small>
              }
              @if (method.paymentMethodType === PaymentMethodType.AchDebit && method.usBankAccount) {
                <small class="text-muted">Bank account</small>
              }
            </div>
          </div>
          @if (isOwnProfile()) {
            <button type="button" class="btn btn-outline-danger btn-sm"
              (click)="openDeleteConfirmation(method.id)">
              <i class="bi bi-trash me-1"></i> Remove
            </button>
          }
        </div>
      </div>
    }
  }
</div>

<ms-confirmation-modal
  #deleteConfirmationModal
  modalId="deletePaymentMethodModal"
  [message]="StripeMessagingConstants.STRIPE_PAYMENT_METHOD_DELETE_CONFIRMATION()"
  confirmButtonText="Remove"
  cancelButtonText="Cancel"
  (confirmed)="confirmDeletePaymentMethod()"
  (cancelled)="cancelDelete()"
  [isSubmitting]="isDeleting()">
</ms-confirmation-modal>

<ms-info-modal
  #paymentInfoModal
  modalId="paymentInfoModal"
  (onConfirm)="closeInfoModal()">
</ms-info-modal>
